<form [formGroup]="integranteFormGroup">
  <div class="row">
    <h4>{{tituloIntegrante}}</h4>
  </div>

  <div class="row">
    <ng-container formGroupName="rol">
      <mat-form-field class="col-xs-6 col-sm-12">
        <mat-label>Tipo de rol</mat-label>
        <mat-select formControlName="tipo_rol_id" required (selectionChange)="onRolSelect($event)">
          <mat-option *ngFor="let rol of formInput.tipos_rol" [value]="rol.id">
            {{rol.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="integranteFormGroup.get('rol')?.hasError('required')">
          Debe ingresar un rol
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="row">
    <mat-form-field class="col-xs-6 col-sm-12">
      <input matInput placeholder="Nombre:" formControlName="nombre_completo" required [disabled]="true">
      <mat-error *ngIf="integranteFormGroup.get('nombre_completo')?.hasError('required')">
        Debe ingresar nombre
      </mat-error>
    </mat-form-field>
  </div>

  <rpe-documento-persona-form [formInput]="documentoPersonaFormInput">
  </rpe-documento-persona-form>

  <div class="row" [hidden]="ocultarAcreditacion()">
    <ng-container formGroupName="rol">
      <mat-form-field appearance="standard">
        <mat-label>Acreditación de representación *</mat-label>
        <ngx-mat-file-input formControlName="acreditacion_representacion" accept="pdf, .jpg, .zip, .rar, .7z"
          (change)="onFileChange('acreditacion_representacion')" placeholder="Acreditación de representación">
        </ngx-mat-file-input>
        <mat-icon matSuffix>
          <fa-icon icon="paperclip"></fa-icon>
        </mat-icon>

        <mat-hint align="end">Tamaño máximo 10 MB en formato pdf, .jpg, .zip, .rar o .7z</mat-hint>
        <mat-error>Debe ingresar un archivo con extensión pdf, .jpg, .zip, .rar o .7z, menor a 10 MB</mat-error>
      </mat-form-field>
      <mat-hint align="end">
        <div class="flex">
          <mat-icon>info</mat-icon>
          <span class="info">Mención en el certificado o carta poder</span>
        </div>
      </mat-hint>
    </ng-container>
  </div>

  <div [hidden]="ocultarActividad()">
    <div *ngFor="let act of formInput.actividadesConNombre; let i=index">
      <input type="checkbox" formArrayName="actividades_id" [value]="act.actividad" id="actCheck_{{act.actividad}}"
        [checked]="estaSeleccionado(act.actividad)" (change)=" onCheckboxChange($event)"
        [disabled]="disabledCheckBox()" />
      <label for="actCheck_{{act.actividad}}"> {{ act.nombreActividad}}</label>
    </div>
    <mat-error *ngIf="integranteFormGroup.get('actividades_id')?.hasError('MinLengthArray')">
      Debe elegir al menos una actividad
    </mat-error>
  </div>


  <div class="row" [hidden]="ocultarCV()">
    <mat-form-field appearance="standard">
      <mat-label>CV *</mat-label>
      <ngx-mat-file-input formControlName="cv" accept="pdf, .jpg, .zip, .rar, .7z" (change)="onFileChange('cv')"
        placeholder="CV"></ngx-mat-file-input>
      <mat-icon matSuffix>
        <fa-icon icon="paperclip"></fa-icon>
      </mat-icon>
      <mat-hint align="end">Tamaño máximo 10 MB en formato pdf, .jpg, .zip, .rar o .7z</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión pdf, .jpg, .zip, .rar o .7z, menor a 10 MB</mat-error>
    </mat-form-field>
  </div>

</form>